<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="titles">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card tile flat>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          autocomplete="off"
          @submit.prevent
        >
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  label="Nome"
                  v-model="data.group_name"
                  :rules="fieldRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-card>
    <v-card elevation="0">
      <v-card class="mt-4">
        <v-toolbar flat color="secondary" dark dense>
          <v-toolbar-title class="titles">Permissões do Grupo</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-row justify="center">
            <v-expansion-panels focusable flat accordion>
              <v-expansion-panel
                v-for="(routes, i) in this.data.group_permissions"
                :key="i"
              >
                <!-- <div v-if="routes.perm && !routes.single">
                  <v-expansion-panel-header class="body-1 text-uppercase font-weight-light">
                    <b>{{!routes.children ? routes.name : routes.children[0].name}}</b>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="mt-5">
                    <v-switch
                      color="green darken-1"
                      class="pa-0 mb-0 mt-0"
                      inset
                      dense
                      v-for="(a,i) in routes.children"
                      :key="i"
                      :label="a.name"
                      v-model="a.active"
                    ></v-switch>
                  </v-expansion-panel-content>
                </div>-->
                <div>
                  <v-expansion-panel-header
                    class="body-1 text-uppercase font-weight-light"
                  >
                    <b>{{ routes.title }}</b>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="mt-5">
                    <v-switch
                      color="green darken-1"
                      class="pa-0 mb-0 mt-0"
                      inset
                      dense
                      :label="routes.show ? 'Liberado' : 'Bloqueado'"
                      v-model="routes.show"
                    ></v-switch>
                  </v-expansion-panel-content>
                </div>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
    <br />
    <br />
    <v-footer fixed color="secondary">
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!valid && loader"
        depressed
        large
        color="primary"
        class="mr-4"
        :loading="loader"
        @click="validate"
        >Confirmar</v-btn
      >
    </v-footer>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    menus: [
      { title: "Dashboard", show: false },
      { title: "Cadastros", show: false },
      { title: "Veículos", show: false },
      { title: "Gerenciar Veiculos", show: false },
      { title: "Situação da Frota", show: false },
      { title: "Modelos", show: false },
      { title: "Marcas", show: false },
      { title: "Cores", show: false },
      { title: "Proprietario", show: false },
      { title: "Gerenciar Proprietario", show: false },
      { title: "Locador", show: false },
      { title: "Gerenciar Locador", show: false },
      { title: "Depedências", show: false },
      { title: "Tipos de Atendimento", show: false },
      { title: "Tipos de Combustível", show: false },
      { title: "Tipos de Consumo", show: false },
      { title: "Tipos de Vínculo", show: false },
      { title: "Fornecedores", show: false },
      { title: "Gerenciar Fornecedores", show: false },
      { title: "Frentistas", show: false },
      { title: "Gerenciar Frentistas", show: false },
      { title: "Usuários", show: false },
      { title: "Gerenciar Usuários", show: false },
      { title: "Grupos de Acesso", show: false },
      { title: "Prefeituras", show: false },
      { title: "Gerenciar Prefeituras", show: false },
      { title: "Licitaçōes", show: false },
      { title: "Gerenciar Licitaçōes", show: false },
      { title: "Tipos de Licitação", show: false },
      { title: "Modelos de Licitação", show: false },
      { title: "Financeiro", show: false },
      { title: "Faturamento", show: false },
      { title: "Motoristas", show: false },
      { title: "Gerenciar Motoristas", show: false },
      { title: "Abastecimento", show: false },
      { title: "Conferência", show: false },
      { title: "Abastecer", show: false },
      { title: "Abastecimentos pelo administrador", show: false },
      { title: "Relatórios pelo administrador", show: false },
      { title: "Conferências pelo administrador", show: false },
      { title: "Bloqueados", show: false },
      { title: "Reajuste", show: false },
      { title: "Relatório Genérico", show: false },
      { title: "Retroatividade", show: false },
      { title: "Relatório TCE", show: false },
      { title: "Relatório TCE: Proprietario Frota", show: false },
      { title: "Relatório TCE: Locador Prestador", show: false },
      { title: "Relatório TCE: Veículos", show: false },
      { title: "Relatório TCE: Máquinas", show: false },
      { title: "Relatório TCE: Situação Frota", show: false },
      { title: "Relatório TCE: Abastecimento", show: false },
      { title: "Nota Fiscal", show: false },
      { title: "Almoxarifado", show: false },
      { title: "Fornecedores | Almoxarifado", show: false },
      { title: "Gerenciar Fornecedores | Almoxarifado", show: false },
      { title: "Licitações | Almoxarifado", show: false },
      { title: "Gerenciar Licitações | Almoxarifado", show: false },
      { title: "Lançar Notas | Almoxarifado", show: false },
      { title: "Gerenciar Notas | Almoxarifado", show: false },
      { title: "Relatórios | Almoxarifado", show: false },
      { title: "Relatório Analítico | Almoxarifado", show: false },
      { title: "Relatório Sintético | Almoxarifado", show: false },
    ],
    data: {
      group_id: null,
      group_name: "",
      group_permissions: [],
    },
  }),
  created() {
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`access-groups/${this.id}`).then((r) => {
        this.data = r.data[0];
        const returnedMenus = JSON.parse(r.data[0].group_permissions);

        returnedMenus.map((p) => {
          this.menus.map((m) => {
            m.title == p.title ? (m.show = p.show) : false;
          });
        });

        this.data.group_permissions = this.menus;
        this.$store.dispatch("setLoader", false);
      });
    } else {
      this.data.group_permissions = this.menus;
      this.$store.dispatch("setLoader", false);
    }
  },
  methods: {
    validate() {
      this.snack.show = true;
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      this.data.group_permissions = JSON.stringify(this.data.group_permissions);
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/access-groups/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            this.$router.push("/access-groups");
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/access-groups", this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            this.$router.push("/access-groups");
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style>
.titles {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.2rem;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
